module.exports = __webpack_public_path__ + "static/img/zeta_template_08.55e5cef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeta_template_08.png
// module id = Vhq3
// module chunks = 1